import { Heading as ThemeUIHeading } from 'theme-ui';

export default function Heading({ as, children, ...props }) {
  return (
    <ThemeUIHeading
      as={as}
      variant={`styles.${as}`}
      {...props}
    >
      {children}
    </ThemeUIHeading>
  );
}
